import {Delete, Get, Post, Put} from "./config";

// Bank Endpoint
export const storeMerchant = (params) => Post('merchants', params);
export const fetchMerchantCode = (params) => Post('merchants/code', params);
export const updateMerchant = (id, params) => Put('merchants', id, params);
export const fetchMerchants = (params) => Get( 'merchants', params);
export const fetchMerchantById = (id) => Get( 'merchants/' + id);
export const deleteMerchantById = (id, params) => Delete( 'merchants/' + id, params);
